import { defineStore } from "pinia";
import axios from "axios";
import { useUserStore } from "@/ai_studio/stores/user";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    authenticated: false,
  }),
  getters: {
    isAuthenticated: (state) => state.authenticated,
  },
  actions: {
    async login(jwt, redirectUrl) {
      const userStore = useUserStore();
      
      try {
        const response = await axios.get(`/api/auth`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
          params: redirectUrl ? { url: redirectUrl } : {},
        });

        if (!response.data?.sucesso) {
          throw new Error("Authentication failed.");
        }

        const fetchedUser = await userStore.getUser();
        this.authenticated = Boolean(fetchedUser);
        return this.authenticated;

      } catch (err) {
        this.logout();
        return false;
      }
    },

    async checkAuth() {
      const userStore = useUserStore();
      const fetchedUser = await userStore.getUser();
      this.authenticated = Boolean(fetchedUser);
      return this.authenticated;
    },

    logout() {
      this.authenticated = false;
      const userStore = useUserStore();
      userStore.clearUser();
    },
  },
});
